"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDashboardStatsResponseDataDto = instanceOfDashboardStatsResponseDataDto;
exports.DashboardStatsResponseDataDtoFromJSON = DashboardStatsResponseDataDtoFromJSON;
exports.DashboardStatsResponseDataDtoFromJSONTyped = DashboardStatsResponseDataDtoFromJSONTyped;
exports.DashboardStatsResponseDataDtoToJSON = DashboardStatsResponseDataDtoToJSON;
exports.DashboardStatsResponseDataDtoToJSONTyped = DashboardStatsResponseDataDtoToJSONTyped;
/**
 * Check if a given object implements the DashboardStatsResponseDataDto interface.
 */
function instanceOfDashboardStatsResponseDataDto(value) {
    if (!('totalListings' in value) || value['totalListings'] === undefined)
        return false;
    if (!('privateSaleCount' in value) || value['privateSaleCount'] === undefined)
        return false;
    if (!('liveAuctionCount' in value) || value['liveAuctionCount'] === undefined)
        return false;
    if (!('reverseAuctionCount' in value) || value['reverseAuctionCount'] === undefined)
        return false;
    if (!('totalCustomers' in value) || value['totalCustomers'] === undefined)
        return false;
    if (!('totalEnquiries' in value) || value['totalEnquiries'] === undefined)
        return false;
    if (!('totalDepositAmountReceived' in value) || value['totalDepositAmountReceived'] === undefined)
        return false;
    return true;
}
function DashboardStatsResponseDataDtoFromJSON(json) {
    return DashboardStatsResponseDataDtoFromJSONTyped(json, false);
}
function DashboardStatsResponseDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'totalListings': json['totalListings'],
        'privateSaleCount': json['privateSaleCount'],
        'liveAuctionCount': json['liveAuctionCount'],
        'reverseAuctionCount': json['reverseAuctionCount'],
        'totalCustomers': json['totalCustomers'],
        'totalEnquiries': json['totalEnquiries'],
        'totalDepositAmountReceived': json['totalDepositAmountReceived'],
    };
}
function DashboardStatsResponseDataDtoToJSON(json) {
    return DashboardStatsResponseDataDtoToJSONTyped(json, false);
}
function DashboardStatsResponseDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'totalListings': value['totalListings'],
        'privateSaleCount': value['privateSaleCount'],
        'liveAuctionCount': value['liveAuctionCount'],
        'reverseAuctionCount': value['reverseAuctionCount'],
        'totalCustomers': value['totalCustomers'],
        'totalEnquiries': value['totalEnquiries'],
        'totalDepositAmountReceived': value['totalDepositAmountReceived'],
    };
}
